export enum AppPermissions {
    cAPBasicUser = 'CAP_Basic_User',
    cAPFeatureAreasCanCreate = 'CAP-Feature_Areas-Can_Create',
    cAPFeatureAreasCanPublish = 'CAP-Feature_Areas-Can_Publish',
    cAPFeatureAreasCanUpdate = 'CAP-Feature_Areas-Can_Update',
    checkRidePilotExaminerAccess = 'Check_Ride-Pilot_Examiner_Access',
    checkRideStudentAccess = 'Check_Ride-Student_Access',
    checkridePaymentCanRefund = 'Checkride_Payment-Can_Refund',
    checkrideSwapCanOverride = 'Checkride_Swap-Can_Override',
    checkrideBasicAccess = 'Checkride-Basic_Access',
    checkrideCanSeeMissedAcsCodes = 'Checkride-Can_See_Missed_Acs_Codes',
    checkrideSchoolAccess = 'Checkride-School_Access',
    entAdminMetaDataCanAdmin = 'Ent_Admin_MetaDataCanAdmin',
    entAdminOtherCanAccess = 'Ent_Admin_OtherCanAccess',
    entAdminSecurityCanAccess = 'Ent_Admin_SecurityCanAccess',
    entAdminSecurityCanAdminAdvanced = 'Ent_Admin_SecurityCanAdminAdvanced',
    entAdminSecurityCanAdminUsers = 'Ent_Admin_SecurityCanAdminUsers',
    entAdminCanAccess = 'Ent_AdminCanAccess',
    entSecurityCanEmulate = 'Ent_Security_CanEmulate',
    entSecurityCanLogin = 'Ent_Security_CanLogin',
    entUiCanConfigure = 'Ent_Ui_CanConfigure',
    entUiContentCanEdit = 'Ent_Ui_Content_CanEdit',
    entWorkItemTrackingCanAccess = 'Ent_WorkItemTracking_CanAccess',
    entWorkItemTrackingCanAdmin = 'Ent_WorkItemTracking_CanAdmin',
    flightSchoolBasicAccess = 'Flight_School-Basic_Access',
    flightSchoolCanManageInstructors = 'Flight_School-Can_Manage_Instructors',
    flightSchoolCanManageSchoolSettings = 'Flight_School-Can_Manage_School_Settings',
    flightSchoolCanManageStudents = 'Flight_School-Can_Manage_Students',
    flightSchoolCanManageUsers = 'Flight_School-Can_Manage_Users',
    flightSchoolCanViewReports = 'Flight_School-Can_View_Reports',
    listAdmin = 'List_Admin',
    pilexosAdmin = 'Pilexos_Admin',
    pilexosUserTypeLimitedMenusCanSeeAll = 'Pilexos-User_Type_Limited_Menus-Can_See_All',
    pilotExaminerCanManage = 'Pilot_Examiner-Can_Manage',
    planOfActionACSCodeLookup = 'Plan_of_Action-ACS_Code_Lookup',
    planOfActionPilotExaminer = 'Plan_of_Action-Pilot_Examiner',
    planOfActionSchoolAccess = 'Plan_Of_Action-School_Access',
    planOfActionStudentAccess = 'Plan_of_Action-Student_Access',
    scheduleBlockAccess = 'Schedule_Block_Access',
    schoolCanManage = 'School-Can_Manage',
}
